import MatrixLookup from './MatrixLookup';
import { evaluateMathOperation } from '../../lib/utils';
import { isEmpty } from '../../lib/utils';
import EvaluateCondition from './EvaluateCondition';

// calculate product price based on user selections

function getPrice(pricing, product){
    let price = 0;

    // Normalize pricing flags from possible shapes:
    // "1,0,0", ["1","0","0"], or JSON-like string '["1","0","0"]'
    const normalizedPricing = Array.isArray(pricing)
        ? pricing
        : String(pricing ?? '')
              .replace(/[\[\]"]/g, '')
              .split(',');
    const pf = normalizedPricing.map((flag) => String(flag ?? '').trim());
    const isEnabled = (flag) => Number.parseInt(String(flag ?? '0').trim(), 10) === 1;
    const asNumber = (value) => {
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : 0;
    };

    if (pf.length > 0) {
        debugger;
        if (isEnabled(pf[0]))
            price = asNumber(product.msrp);
        if (isEnabled(pf[1]))
            price = asNumber(product.wholeSalePrice);
        if (isEnabled(pf[2]))
            price = product.isConfigKit === "N" ? asNumber(product.wholeSalePrice) : asNumber(product.basePrice);
    }
    return price;
}

function formulaConditions(priceFormula)
{
    let dependentConditions = {};
 
    for (let pf of priceFormula) {
        // populate conditions object with condition used in the question
        if (!isEmpty(pf.condition)) {
            dependentConditions[pf.condition] = pf.conditions;
        }
    }
    return dependentConditions;
}

function evaluateFormulaCondition(formulaConditions, answers, matrixData, configGroup, qty)
{
   
    const evaluationResult = {};
    for (const [conditionName, conditions] of Object.entries(formulaConditions)) {
        //if(conditionName === "CHAN_MAR_NON_CENT")
        evaluationResult[conditionName] = EvaluateCondition(
            conditions,
            answers,
            matrixData,
            configGroup,
            qty
        );
    }
    
    return evaluationResult;
    
}

function configKitBasePriceOverride(varName, existValue){
    if(varName === "basePrice" )
        return 0;
    return existValue;

}

 
 
function sortFormula(priceFormula) {
    return priceFormula.sort((a, b) => {
        // Check if variable1 includes "PRICE" (but not "BASE_PRICE")
        const aVariable1IncludesPrice = a.variable1.toUpperCase().includes('PRICE') && !a.variable1.toUpperCase().includes('BASE_PRICE');
        const bVariable1IncludesPrice = b.variable1.toUpperCase().includes('PRICE') && !b.variable1.toUpperCase().includes('BASE_PRICE');

        // Check if variable2 is empty or blank
        const aVariable2IsEmpty = !a.variable2 || a.variable2.trim() === '';
        const bVariable2IsEmpty = !b.variable2 || b.variable2.trim() === '';

        if (aVariable1IncludesPrice && !bVariable1IncludesPrice) {
            return -1; // a comes before b
        }
        if (!aVariable1IncludesPrice && bVariable1IncludesPrice) {
            return 1; // b comes before a
        }

        // When both have variable1 including "PRICE"
        if (aVariable1IncludesPrice && bVariable1IncludesPrice) {
            if (aVariable2IsEmpty && !bVariable2IsEmpty) {
                return -1; // a comes before b
            }
            if (!aVariable2IsEmpty && bVariable2IsEmpty) {
                return 1; // b comes before a
            }
            return -1; // maintain order when both are empty or both have values
        }

        // Maintain original order for other cases
        return 99;
    });
}

export function calculatePrice(priceFormula, matrixData, answers, product, qty, pricing) {
    let pricingObject = {};
    let upcharges = [];
    let price = 0;
    let totalDiscount = 0;
    product.basePrice = getPrice(pricing, product);
    
    let dfi = 0; //product.dfi;
    let origPrice = product.basePrice;
    let conditions = formulaConditions(priceFormula);
 
    const conditionsEvalResult = evaluateFormulaCondition(
        conditions,
        answers,
        matrixData,
        product.configGroup,
        qty
    );

    let sortedPriceFormula = product["isConfigKit"] === "Y" ? sortFormula(priceFormula) : priceFormula;

    let basePriceOverriden = false;
    let marineReadyApplied = false;
    //evaluate individual item in the price formula and add to previous value of price
    
    for (let item of sortedPriceFormula) {
        //checkCondition

        if(item.condition.trim() === "" || conditionsEvalResult[item.condition])
        {
            let { formulaPart, variable1, matrix1, operator1to2, variable2,  matrix2, operator2to3, variable3,  matrix3, operator3to4, variable4,  matrix4} = item;
           
            
            // change variable name of 'BASE_PRICE' as the product object has property 'basePrice'
            if (variable1 === 'BASE_PRICE' || variable1 === 'BASE_PRC_CAD') variable1 = 'basePrice';
            if (variable2 === 'BASE_PRICE' || variable2 === 'BASE_PRC_CAD') variable2 = 'basePrice';
            if (variable3 === 'BASE_PRICE' || variable3 === 'BASE_PRC_CAD') variable3 = 'basePrice';
            if (variable4 === 'BASE_PRICE' || variable4 === 'BASE_PRC_CAD') variable4 = 'basePrice';

              
            // do matrix lookup as required, else get the value from product object
            let value1;
            if (!isEmpty(variable1)) {
                // Check if variable1 is a numeric value
                const numericValue = parseFloat(variable1);
                if (!isNaN(numericValue)) {
                    // If variable1 is a numeric string or number, use it directly
                    value1 = numericValue;
                } else if (matrix1) {
                    // If variable1 requires matrix lookup

                     if(variable1 ==="VXQ_GRL_PRICE")
                     {
                        debugger;
                        value1 = MatrixLookup(variable1, answers, matrixData, false, 0);
                     }
                      
                    else{
                        if(variable1 ==="MTX_OWM_SPKR_PRICE");
                        value1 = MatrixLookup(variable1, answers, matrixData, false, dfi);
                    } 
                } else {
                    if(variable1==='basePrice' && product["isConfigKit"] === "N")
                        value1 = product.basePrice
                    else
                        value1 = answers[variable1];// Otherwise get from answers object
                }
            } else {
                value1 = 0;
            }
            value1 = Number(value1) || 0;
            
            let value2;
            if (!isEmpty(variable2)) {
                // Check if variable2 is a numeric value
                const numericValue = parseFloat(variable2);
                if (!isNaN(numericValue)) {
                    // If variable2 is a numeric string or number, use it directly
                    value2 = value1 === 0 && matrix1 ? 0 : numericValue;
                } else if (matrix2) {
                    // If variable2 requires matrix lookup
                    value2 = MatrixLookup(variable2, answers, matrixData,false, dfi);
                } else {
                        if(variable2==='basePrice' && product["isConfigKit"] === "N")
                            value2 = product.basePrice
                        else
                            value2 = answers[variable2];  // Otherwise get from answers object
                       
                }
            } else {
                value2 = 0;
            }
            value2 = Number(value2) || 0;
            
            
            let value3;
            if (!isEmpty(variable3)) {
                // Check if variable3 is a numeric value
                const numericValue = parseFloat(variable3);
                if (!isNaN(numericValue)) {
                    // If variable3 is a numeric string or number, use it directly
                    value3 = value2 === 0 && matrix2 ? 0 : numericValue;
                } else if (matrix3) {
                    // If variable3 requires matrix lookup
                    value3 = MatrixLookup(variable3, answers, matrixData, false, dfi);
                } else {
                    if(variable3==='basePrice' && product["isConfigKit"] === "N")
                        value3 = product.basePrice
                    else
                        value3 = answers[variable3];  // Otherwise get from answers object
                }
            } else {
                value3 = 0;
            }
            value3 = Number(value3) || 0;
            
            let value4;
            if (!isEmpty(variable4)) {
                // Check if variable4 is a numeric value
                const numericValue = parseFloat(variable4);
                if (!isNaN(numericValue)) {
                    // If variable4 is a numeric string or number, use it directly
                    value4 = value3 === 0 && matrix3 ? 0 : numericValue;
                } else if (matrix4) {
                    // If variable4 requires matrix lookup
                    value4 = MatrixLookup(variable4, answers, matrixData,false, dfi);
                } else {
                    if(variable4==='basePrice' && product["isConfigKit"] === "N")
                        value4 = product.basePrice
                    else
                        value4 = answers[variable4];  // Otherwise get from answers object
                }
            } else {
                value4 = 0;
            }
            value4 = Number(value4) || 0;
 
   
            if(product["isConfigKit"] === "Y" && variable1 === 'basePrice' )
               console.log("skip base price for configured kit");
            else {
                if (!isEmpty(variable1)) {
                    let expressionValue = value1;
            
                    // If variable2 exists, compute value1 operator1to2 value2
                    if (!isEmpty(variable2)) {
                        expressionValue = evaluateMathOperation(expressionValue, value2, operator1to2, false, 0);
                        
                        // If variable3 exists, compute (previous result) operator2to3 value3
                        if (!isEmpty(variable3)) {
                            expressionValue = evaluateMathOperation(expressionValue, value3, operator2to3,false , 0);
                            
                            // If variable4 exists, compute (previous result) operator3to4 value4
                            if (!isEmpty(variable4)) {
                                expressionValue = evaluateMathOperation(expressionValue, value4, operator3to4 ,false , 0);
                            }
                        }
                       
                    }
                
            
                    // Add the final computed value to the price
                    if (expressionValue > 0 || (value1 !== 0 || value2 !== 0 || value3 !== 0 || value4 !== 0)) {
                        
                        if(expressionValue > 0)
                        {
                     
                            if(variable1 === "basePrice")
                                variable1 = "BASE_PRICE"; 
                            debugger;
                            upcharges.push({
                                "description" : item.formulaPartDesc || variable1,
                                "amount" : expressionValue
                            });
                        }
                        price = evaluateMathOperation(price, expressionValue, '+',false , 0 );
                    }
                }
            }
           
                
             
         
           
            
        }  
        // else
        // {
        //     price = evaluateMathOperation(price, 0, '+');
        // }
    }


    if(price <= 0){
        pricingObject.price = origPrice;
        return pricingObject;
    }
        
    //  else if(price < product["basePrice"])
    //       return price + origPrice;
    
    // Sort upcharges by amount descending before returning
    const sortedUpcharges = upcharges.slice().sort((a, b) => Number(b.amount || 0) - Number(a.amount || 0));
    pricingObject = {
        upcharges : sortedUpcharges,
        price : price
    };
    return pricingObject;
}
